import { render, staticRenderFns } from "./ResultColumnModal.vue?vue&type=template&id=6827d0fd"
import script from "./ResultColumnModal.vue?vue&type=script&lang=js"
export * from "./ResultColumnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports